import { DIRECTUS_INSTANCE } from '../api';
import { createAccountClient } from './accountClient';

const BILLING_API_BASE = process.env.REACT_APP_BILLING_API_URL || 'http://localhost:4010';

const accountClient = createAccountClient({
  directusBaseUrl: DIRECTUS_INSTANCE,
  billingBaseUrl: BILLING_API_BASE,
  getAccessToken: () => localStorage.getItem('directus_token') || sessionStorage.getItem('directus_token')
});

export const getWorkspaceBillingStatus = async (workspaceId = null) => {
  return accountClient.getWorkspaceBillingStatus(workspaceId);
};

export const createSubscriptionCheckout = async ({ workspaceId, priceId, successUrl, cancelUrl }) => {
  return accountClient.createSubscriptionCheckout({
    workspaceId,
    priceId,
    successUrl,
    cancelUrl
  });
};

export const createTopupCheckout = async ({ workspaceId, topupPriceId, quantity = 1, successUrl, cancelUrl }) => {
  return accountClient.createTopupCheckout({
    workspaceId,
    topupPriceId,
    quantity,
    successUrl,
    cancelUrl
  });
};

export const claimCheckout = async ({ sessionId } = {}) => {
  return accountClient.claimCheckout({ sessionId });
};

export const createBillingPortal = async ({ workspaceId }) => {
  return accountClient.createBillingPortal({
    workspaceId
  });
};
